import React, { useState, useEffect } from "react";
import { usePostHog } from 'posthog-js/react';
import { captureEvent, captureError } from "../utils/posthogUtils";

const CreateUser = () => {
  const [form, setForm] = useState({
    EmpCode: "",
    FirstName: "",
    LastName: "",
    Role: "",
    Location: "",
    department_id: "",
    ContactNo: "",
    email: "",
    password: "",
  });
  const [message, setMessage] = useState("");
  const [departments, setDepartments] = useState([]);
  const posthog = usePostHog();

  useEffect(() => {
    // Fetch departments from backend
    const fetchDepartments = async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_BASE_URL}api/auth/departments`
        );
        const data = await res.json();
        setDepartments(data);
      } catch (err) {
        setDepartments([]);
      }
    };
    fetchDepartments();
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}api/auth/create`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(form),
        }
      );
      const data = await response.json();
      if (response.ok) {
        captureEvent(posthog, 'User Created', { email: form.email, role: form.Role });
        setMessage(data.message);
        setForm({
          EmpCode: "",
          FirstName: "",
          LastName: "",
          Role: "",
          Location: "",
          department_id: "",
          ContactNo: "",
          email: "",
          password: "",
        });
      } else {
        captureError(posthog, 'User Creation Failed', new Error(data.message || "Error creating user"), { email: form.email });
        setMessage(data.message || "Error creating user");
      }
    } catch (err) {
      captureError(posthog, 'User Creation Failed', err, { email: form.email });
      setMessage("Network error");
    }
  };

  return (
    <div
      style={{
        maxWidth: 500,
        margin: "40px auto",
        padding: 20,
        border: "1px solid #ccc",
        borderRadius: 8,
      }}
    >
      <h2>Create User</h2>
      <form onSubmit={handleSubmit}>
        <div>
          <label>EmpCode:</label>
          <br />
          <input
            name="EmpCode"
            value={form.EmpCode}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <label>First Name:</label>
          <br />
          <input
            name="FirstName"
            value={form.FirstName}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <label>Last Name:</label>
          <br />
          <input
            name="LastName"
            value={form.LastName}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <label>Role:</label>
          <br />
          <input
            name="Role"
            value={form.Role}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <label>Location:</label>
          <br />
          <input
            name="Location"
            value={form.Location}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <label>Department:</label>
          <br />
          <select
            name="department_id"
            value={form.department_id}
            onChange={handleChange}
            required
            style={{
              width: "100%",
              padding: "8px 12px",
              borderRadius: "4px",
              border: "1px solid #ccc",
              fontSize: "16px",
              backgroundColor: "white"
            }}
          >
            <option value="">Select Department</option>
            {departments.map((dept) => (
              <option key={dept.id} value={dept.id}>
                {dept.name}
              </option>
            ))}
          </select>
        </div>
        <div>
          <label>Contact No.:</label>
          <br />
          <input
            name="ContactNo"
            value={form.ContactNo}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <label>Email:</label>
          <br />
          <input
            name="email"
            type="email"
            value={form.email}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <label>Password:</label>
          <br />
          <input
            name="password"
            type="password"
            value={form.password}
            onChange={handleChange}
            required
          />
        </div>
        <button type="submit" style={{ marginTop: 12 }}>
          Create User
        </button>
      </form>
      {message && <div style={{ marginTop: 16 }}>{message}</div>}
    </div>
  );
};

export default CreateUser;
